import { createTheme } from "@mui/material/styles";

const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#E8503A",
    },
    secondary: {
      main: "#ff9100",
    },
    background: {
      primary: "#FFFFFF",
      secondary: "#F8F8F8",
      tertiary: "#FDEEEB",
      foreground: "#B8B4FF",
      default: "#f5f5f5",
      paper: "#FFFFFF",
    },

    text: {
      primary: "#000000",
      secondary: "#454545",
      tertiary: "#606067",
      quaternary: "#FFFFFF",
      orange: "#E8503A",
    },

    border: {
      default: "#CECECE",
      primary: "#144F79",
      secondary: "#025D86",
      divider: "#989DA5",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2.5rem",
      fontWeight: 700,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 700,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 600,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 500,
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 500,
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.5,
    },
    button: {
      fontSize: "1rem",
      textTransform: "none", // Disable uppercase
      fontWeight: 500,
    },
    caption: {
      fontSize: "0.75rem",
      fontWeight: 400,
    },
  },
});

export default lightTheme;
